import 'arrive';
import $ from 'jquery';
import LazyLoad from "vanilla-lazyload";
import 'waypoints/lib/noframework.waypoints.min.js';
import {ScrollTrigger} from "../lib/_scroll-trigger";
import {gsap} from "gsap";

gsap.registerPlugin(ScrollTrigger);

const globalScrub = 1;

document.arrive('.block-history', {existing: true}, function() {

    $('.image-history-lazy').each((k,el) => {
        $(el).attr('src', $(el).data('src'))
    })

    const initHistoryImage = new LazyLoad({
        elements_selector: '.image-history-lazy',
        thresholds: "100% 800px",
    });

    $('.timeline-nav .close').click(function(e) {
        $('.timeline-nav').removeClass('open');
    })
});

/**
 * scrollTo with callback
 * @param offset - offset to scroll to
 * @param callback - callback function
 */
function scrollTo(offset, callback) {
    const fixedOffset = offset.toFixed();
    const onScroll = function() {
        if (window.pageYOffset.toFixed() === fixedOffset) {
            window.removeEventListener('scroll', onScroll)
            callback()
        }
    }
    window.addEventListener('scroll', onScroll)
    onScroll()
    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    })
}

document.arrive('.btn-to-time', {existing: true}, function() {
    $(this).on('click', function(event){
        let $btn = $(this);
        let id_click_btn = $btn.data('time');
        $('body').addClass('scrolling-timeline-click');

        scrollTo($(id_click_btn).offset().top - 100, function() {
            $('body').removeClass('scrolling-timeline-click');
        });

        $('.btn-to-time').removeClass('active');
        $btn.addClass('active');

        if ($(window).width() < 992) {
            let $timeline = $(this).parent();
            $timeline.toggleClass('open');
        }
    });
});

$(window).scroll(setCurrentYear);

function setCurrentYear(e) {
    if(!$('body').hasClass('scrolling-timeline-click')) {
        $('.btn-to-time').each(function() {
            var $this = $(this);
            let id_click_btn = $this.data('time');
            var offset = $(id_click_btn).offset().top - 100;
            var scrollTop = $(window).scrollTop();
            if (scrollTop > offset) {
                $('.btn-to-time.active').removeClass('active');
                $this.addClass('active');
            }
        });
    }
}

import './by-year/_1970'
import './by-year/_1980'
import './by-year/_1990'
import './by-year/_2000'
import './by-year/_2010'
import './by-year/_2020'